import { create } from 'zustand';

import { ICommonStore } from './types';

export const commonStoreValues: Readonly<ICommonStore> = {
  user: null,
  retailers: [],
  idToken: '',
  accessToken: '',
  isRiceAvailable: true,
  isSessionExpired: false,
  isRefetchCommonData: false,
};

export const commonStore = create<ICommonStore>()(() => commonStoreValues);
